<app-page-bar></app-page-bar>

<app-page>

  <h2>{{title}}</h2>

  <section>
    <!--
    <app-list-filter-group>
      <app-text-list-filter [list]="list"></app-text-list-filter>
      <app-invoice-state-list-filter [list]="list" filter="invoiceStateId"></app-invoice-state-list-filter>
      <app-invoice-configuration-list-filter [list]="list" filter="invoiceConfigurationId"></app-invoice-configuration-list-filter>
      <app-reset-list-filter [list]="list"></app-reset-list-filter>
    </app-list-filter-group>

    -->
    <div class="filter">
      <mat-form-field class="query">
        <mat-icon matPrefix>search</mat-icon>
        <!--<input #in (input)="dataSource.queryBy({q: in.value})" type="text" matInput>-->
        <input #in (input)="updateQuery({q: in.value})" type="text" matInput [value]="iq.q">
      </mat-form-field>
      <app-multi-select-filter *ngIf="states$ | async as states"
                               [items]="states"
                               [value]="iq.states"
                               (selectionChange)="updateQuery({states: $event})"
                               label="States"
                               idProp="id"
                               labelProp="name">
                            </app-multi-select-filter>
      <app-multi-select-filter *ngIf="configurations$ | async as configurations"
                               [items]="configurations"
                               [value]="iq.configurations"
                               (selectionChange)="updateQuery({configurations: $event})"
                               label="Configurations"
                               idProp="id"
                               labelProp="name">
                            </app-multi-select-filter>
      <button type="button" mat-icon-button (click)="reset()"><mat-icon>clear</mat-icon></button>
    </div>

    <div class="table-container mat-elevation-z8">

      <mat-table #table [dataSource]="dataSource">

        <!-- The hold indicator: financing_on_hold is true while any active
             financing hold applies to the invoice (add-financing-holds). -->
        <ng-container matColumnDef="financing_on_hold">
          <mat-header-cell *matHeaderCellDef><span class="cdk-visually-hidden">Financing hold</span></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon
              *ngIf="element.financing_on_hold"
              class="financing-hold-indicator"
              color="warn"
              aria-hidden="false"
              aria-label="On financing hold"
              matTooltipPosition="right"
              [matTooltip]="holdTooltip(element)">pan_tool</mat-icon>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="number">
          <mat-header-cell *matHeaderCellDef>Number</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.number}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="new_number">
          <mat-header-cell *matHeaderCellDef>New Number</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.new_number}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="configuration_id">
          <mat-header-cell *matHeaderCellDef>Configuration</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ (configurationsMap$ | async)?.get(element.configuration_id)?.name || '—' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="client.name">
          <mat-header-cell *matHeaderCellDef>Client</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.client?.name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="end_customer.name">
          <mat-header-cell *matHeaderCellDef>End Customer</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.end_customer?.name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="amount.amount">
          <mat-header-cell *matHeaderCellDef>Amount</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.amount?.amount | currency:'EUR'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="due_date">
          <mat-header-cell *matHeaderCellDef>Due Date</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.due_date | date}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="state.name">
          <mat-header-cell *matHeaderCellDef>State</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.state.name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <mat-header-cell *matHeaderCellDef>Created</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.created_at | date:'short'}}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns;" matRipple
                 [routerLink]="['/invoices', row.id]"></mat-row>

      </mat-table>
    </div>
  </section>
</app-page>
